/*
 * @Description: 公共参数
 * @FilePath: \vue2\src\config.js
 */

module.exports = {
  baseURL: 'https://web3crypte.com/api',
  socketUrl: 'https://web3crypte.com',
  whiteList: [
  ],
};
